<template>
  <!-- Feature Sections > With large screenshot -->
   <div id="funktionen" class="bg-white py-24 sm:py-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="mx-auto max-w-2xl sm:text-center">
        <h2 class="text-lg font-semibold leading-8 tracking-tight text-teal-500">
          Gebaut für Podcaster*innen
        </h2>
        <p class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          Produktion kannst du.<br />
          Jetzt klappt auch die Distribution.
        </p>
        <p class="mt-6 text-lg leading-8 text-gray-600">
          Du musstest dir bereits so viele Audio-Skills aufbauen – vom Storytelling bis hin zu Tontechnik und Schnitt. Wo soll da auch noch Know-how zum Thema Marketing herkommen? Im Studio findest du Wissen und Anleitung.
        </p>
      </div>
    </div>
    <div class="relative overflow-hidden pt-16">
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <img src="/images/index-3.png" alt="Methoden-Übersicht in St. Audio" class="mb-[-12%] rounded-xl shadow-2xl ring-1 ring-gray-900/10" width="2960" height="1804" />
        <div class="relative" aria-hidden="true">
          <div class="absolute -inset-x-20 bottom-0 bg-gradient-to-t from-white pt-[7%]" />
        </div>
      </div>
    </div>
    <div class="mx-auto mt-16 max-w-7xl px-6 sm:mt-20 md:mt-24 lg:px-8">
      <dl class="mx-auto grid max-w-2xl grid-cols-1 gap-x-6 gap-y-10 text-base leading-7 text-gray-600 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3 lg:gap-x-8 lg:gap-y-16">
        <div v-for="feature in features" :key="feature.name" class="relative pl-9">
          <dt class="inline font-semibold text-gray-900">
            <component :is="feature.icon" class="absolute top-1 left-1 h-5 w-5 text-teal-500" aria-hidden="true" />
            {{ feature.name }}
          </dt>
          {{ ' ' }}
          <dd class="inline">{{ feature.description }}</dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script setup>
import { StarIcon } from '@heroicons/vue/20/solid';
import { FireIcon } from '@heroicons/vue/20/solid';
import { AdjustmentsHorizontalIcon } from '@heroicons/vue/20/solid';
import { BoltIcon } from '@heroicons/vue/20/solid';
import { UsersIcon } from '@heroicons/vue/20/solid';
import { BellIcon } from '@heroicons/vue/20/solid';
import { ChartPieIcon } from '@heroicons/vue/20/solid';
import { FingerPrintIcon } from '@heroicons/vue/20/solid';
import { GiftIcon } from '@heroicons/vue/20/solid';

const features =
[
  {
    name: 'Starten:',
    description: 'Im Onboarding geht es mit der Auswahl von Wachstumszielen und Metriken los, die du im Blick behalten möchtest.',
    icon: StarIcon,
  },
  {
    name: 'Fokussieren:',
    description: 'Anhand des Empfehlungswertes liest du auf einen Blick ab, welche Methode derzeit das größte Potential hat.',
    icon: FireIcon,
  },
  {
    name: 'Filtern:',
    description: 'Lass dir Ideen nach Thema, Wachstumsphase, Zeit- oder Geldeinsatz anzeigen. Oder alles zusammen.',
    icon: AdjustmentsHorizontalIcon,
  },
  {
    name: 'Planen:',
    description: 'Merke dir Methoden vor und markiere diese als zeitlich befristet oder dauerhaft angewandt.',
    icon: BoltIcon,
  },
  {
    name: 'Kooperieren:',
    description: 'Arbeite mit beliebig vielen Coworker*innen gemeinsam am Wachstum deines Podcasts.',
    icon: UsersIcon,
  },
  {
    name: 'Erinnern:',
    description: 'Deine Kompass-KI meldet sich mit neuen Ideen oder sobald es Zeit für eine Zwischenauswertung ist.',
    icon: BellIcon,
  },
  {
    name: 'Auswerten:',
    description: 'Bemiss die Wirksamkeit deiner angewandten Methoden in Hinblick auf deine Wachstumsziele.',
    icon: ChartPieIcon,
  },
  {
    name: 'Schützen:',
    description: 'Dein Podcast liegt sicher mit SSL-Zertifikat im Studio, gehostet auf deutschen Servern. Und nur du siehst deine Metriken.',
    icon: FingerPrintIcon,
  },
  {
    name: 'LAUNCH-BONUS:',
    description: 'Wir schenken dir die Edition I unserer Methoden-Sammlung mit 99 Ideen zum Podcast-Wachstum.',
    icon: GiftIcon,
  },
];
</script>
